import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* getDonationSettings(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DONATION.GET, null, true);
}

export function* insertUpdateDonationSettings(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.DONATION.INSERT_UPDATE, action.payload, true);
}
